import BaseFormLabel from '@material-ui/core/FormLabel'

const FormLabel = BaseFormLabel

export default FormLabel
